export const budgetNeedsReview = (initialValue: string | number | null, currentValue: string | number | null): boolean => {
  if (initialValue === null || (Number(initialValue) === 0 && Number(currentValue) > 0)) {
    return true
  }
  const changePercent = (Number(currentValue) - (Number(initialValue))) / Number(initialValue)
  if (Math.abs(changePercent) > 0.1) {
    return true
  }
  return false
}
